import {AuswahlProdukt, Feature, FeaturedObject, Product, SelectedFeature} from "./product";
import {
    ProduktAuswahlFeature,
    ProduktAuswahlFeaturedObject,
    ProduktAuswahlProdukt
} from "../../konfi_mobile/src/store/ProduktAuswahlStore";

export class SelectedFeatureFromProductGetter {
    public static getSelectedFeatures(produkt:AuswahlProdukt|ProduktAuswahlProdukt, currentOwayoProduct:Product) {
        return produkt.FeaturedObjects.reduce(function (carry, produktFeaturedObject) {
            if (typeof (produktFeaturedObject.Features) === "undefined") {
                carry.push(SelectedFeatureFromProductGetter.getFeaturedObjectWithStandardFeature(produktFeaturedObject));
                return carry;
            }
            if (produktFeaturedObject.Features.length === 0) {
                return carry;
            }
            const feature = SelectedFeatureFromProductGetter.getFeatureByFeaturedObjectAndProduct(produkt, currentOwayoProduct, produktFeaturedObject);
            carry.push(SelectedFeatureFromProductGetter.getSelFeature(produktFeaturedObject.FeaturedObject, feature, produktFeaturedObject.zeigeZugehoerigeFeatureBeiFeatureAuswahlAn));
            return carry;
        }, [] as SelectedFeature[]);
    }

    public static getFeatureByFeaturedObjectAndProduct(produkt: AuswahlProdukt|ProduktAuswahlProdukt, currentOwayoProduct:Product, produktFeaturedObject: FeaturedObject|ProduktAuswahlFeaturedObject):Feature {
        // wir checken ob wir aus dem aktuell geladenen Entwurf die Features für die Darstellung
        // der Featureauswahl ermitteln können.
        // Dann sollten nicht immer die Standardfeature sondern die zuletzt gewählten gezeigt werden

        let feature = undefined as Feature|undefined|ProduktAuswahlFeature;
        if (SelectedFeatureFromProductGetter.auswahlproduktSeemsToBeTheSameAsCurrentOwayoProductBasedOnOrdertypeSchnittAndDVSchnitt(produkt, currentOwayoProduct)) {
            const features = currentOwayoProduct.selectedFeatures;
            for (let i = 0; i < features.length; i++) {
                if (produktFeaturedObject.FeaturedObject === features[i].featuredObject) {
                    feature = produktFeaturedObject.Features.find(f=>f.Feature === features[i].feature);
                }
            }
        }

        if (!feature) {
            feature = produktFeaturedObject.Features.find(f=>f.Feature === produktFeaturedObject.StandardFeature);
        }

        // wenn wir das Standard Feature nicht gefunden haben, so nehmen wir einfach das erste als Standard
        if (!feature) {
            feature = produktFeaturedObject.Features[0];
        }
        return feature as Feature;
    }

    private static getFeaturedObjectWithStandardFeature(produktFeaturedObject: FeaturedObject|ProduktAuswahlFeaturedObject) {
        return new SelectedFeature(
            produktFeaturedObject.FeaturedObject,
            // produktFeaturedObject.Name,
            produktFeaturedObject.StandardFeature,
            produktFeaturedObject.StandardFeature,
            null,
            '',
            "0",
            "1",
            produktFeaturedObject.zeigeZugehoerigeFeatureBeiFeatureAuswahlAn
        );
    }

    private static auswahlproduktSeemsToBeTheSameAsCurrentOwayoProductBasedOnOrdertypeSchnittAndDVSchnitt(produkt: AuswahlProdukt|ProduktAuswahlProdukt, currentOwayoProdcut:Product) {
        return produkt.Ordertype === currentOwayoProdcut.ordertype &&
            ((produkt.Schnitt === currentOwayoProdcut.cut) ||
                (produkt.DVSchnitt === currentOwayoProdcut.cut) ||
                produkt.Schnitt === currentOwayoProdcut.schnitt);
    }


    private static getSelFeature(featuredObjectName: string, feature:Feature, showFeaturedObject: string) {
        return new SelectedFeature(
            featuredObjectName,
            feature.Feature,
            feature.Name,
            feature.Kuerzel,
            feature.einzublendendeDreiDParts,
            feature.imKonfiBeiDerProduktuebersichtAuswaehlbar,
            feature.imKonfiVerstecktesAberFuerPreisberechnungRelevantesFeature,
            showFeaturedObject);
    }
}
